import "./style.css";
import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Legend } from "recharts";
import renderData from "../../../../../../utils/renderData";


export default function PieChartCom(props) {
  const [data , setData] = useState([])
  useEffect(()=>{
    const group = props.data.map((da) => {
        const mainGroup = renderData.pointsGroups.find((group) => group.name === da.name)         
        return {name:mainGroup?.[window.lang],value:da.value}
    }
    )
        setData(group)
  


},[props.data])

// const data = [
//   { name: "Group A", value: 400 },
//   { name: "Group B", value: 300 },
//   { name: "Group C", value: 300 },
//   { name: "Group D", value: 600 },
// ];
const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}: any) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {/* {`${data[index].name} ${(percent * 100).toFixed(0)}%`} */}
      {/* {`${data[index]?.name} \n ${data[index]?.value}pts`} */}
      {`${data[index]?.value}`}
    </text>
  );
};
  return (
    <PieChart width={400} height={400}>
      <Pie
        data={data}
        cx={200}
        cy={200}
        labelLine={false}
        label={renderCustomizedLabel}
        outerRadius={80}
        fill="#8884d8"
        dataKey="value"
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
        ))}
      </Pie>        
        <Legend layout="vertical" align="center" />
    </PieChart>
  );
}
